/** Server-projected purchase-decision factors and explicitly separate non-role notes. */
import * as z from 'zod';
export const shopifyStudyDecisionClassificationResultsSchema = z
    .object({
    status: z.enum(['complete', 'unavailable', 'sample']),
    sample: z
        .object({
        provider: z.literal('cloudflare'),
        model: z.literal('@cf/cloudflare/clef'),
        classificationVersion: z
            .enum([
            'consideration-classification.v1',
            'consideration-classification.v2',
            'consideration-classification.v3',
            'consideration-classification.v4',
            'consideration-classification.v5',
        ])
            .optional(),
        selectedResponseCount: z.number().int().min(6).max(12),
        totalEligibleResponseCount: z.number().int().min(6),
    })
        .strict()
        .optional(),
    objective: z.string().nullable().optional(),
    decision: z.string().nullable().optional(),
    codebookVersion: z.string().optional(),
    buckets: z.array(z.object({
        id: z.string(),
        factorLabel: z.string(),
        role: z.enum(['driver', 'barrier', 'condition', 'mention_only', 'delay', 'unclear', 'role_unassigned']),
        responses: z.array(z.object({
            text: z.string(),
            armId: z.string(),
            armLabel: z.string(),
            respondentLabel: z.string(),
            probability: z.number().min(0).max(1).optional(),
            confidence: z.number().min(0).max(1).optional(),
        })),
    })),
    reviewResponses: z.array(z.object({
        text: z.string(),
        armId: z.string(),
        armLabel: z.string(),
        respondentLabel: z.string(),
        reason: z.enum(['mention_only', 'unclear', 'no_decision_factor', 'role_unassigned']),
        factorLabel: z.string().nullable(),
        probability: z.number().min(0).max(1).optional(),
        confidence: z.number().min(0).max(1).optional(),
    })),
})
    .strict();
//# sourceMappingURL=shopify-study-decision-classifications.js.map